<template>
    <div class="landing-page text-center flex flex-col flex-grow">
        <div class="landing-ilustration-wrapper mx-auto mb-5" role="complementary" aria-label="Banner image">
            <img
                class="img-fluid"
                :src="landingIlustration"
                :alt="currentSite === 'cor ' ? 'Person avatars in a interconnecting grid' : 'Two persons shaking hands'"
            />
        </div>
        <div class="page-content mx-auto" role="main" aria-label="Institution name">
            <h1 
                class="page-title fw-bold text-primary"
            >
                {{ $t('system_name') }}
                <br />
                {{ $t(isCORSite ? 'lib_cor' : 'lib_eesc') }}
            </h1>

            <p class="page-subtitle" v-html="$t('welcome_login')"></p>
            <button
                type="button"
                @click="goToLogin()"
                class="login-btn btn btn-lg btn-primary px-4 py-2"
            >
                {{ $t('btn_login') }}
            </button>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { defineComponent } from 'vue';
import corIlustration from '@/assets/images/cor-landing-illustration.svg';
import eescIlustration from '@/assets/images/eesc-landing-illustration.svg';

export default defineComponent({
    name: 'LandingPage',
    components: {},
    computed: {
        ...mapGetters(['selectedLanguage', 'isCORSite', 'currentSite']),
        landingIlustration() {
            return this?.currentSite?.toLowerCase() === 'cor'
                ? corIlustration
                : eescIlustration;
        },
    },
    methods: {
        ...mapActions(['loadAppData']),
        goToLogin() {
            window.location.href = `/${this.selectedLanguage}/account/login`;
        },
    },
    created() {
        // this.loadAppData();
    },
    data() {
        return {};
    },
});
</script>
